import { useQuery } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'
import { CreativeImportProgress } from '@marketing-milk/interfaces'
import { isTerminalJobStatus } from './state'

/** One-shot progress fetch — used by the page's reopen-by-URL hydration. */
export const fetchCreativeImportProgress = async (
  businessID: number | string,
  creativeImportID: number
): Promise<CreativeImportProgress> => {
  const response = await NestAPI.get<CreativeImportProgress>(
    `businesses/${businessID}/creative-import/${creativeImportID}`
  )
  return response.data
}

/** Polls import progress every 2s until the job reaches a terminal status. */
export const useCreativeImportProgress = (creativeImportID: number | null, enabled: boolean) => {
  const business = useGetBusiness()

  return useQuery<CreativeImportProgress>(
    ['creative-import-progress', business.id, creativeImportID],
    () => fetchCreativeImportProgress(business.id, creativeImportID!),
    {
      enabled: enabled && creativeImportID !== null,
      refetchInterval: data => (data && isTerminalJobStatus(data.status) ? false : 2000),
    }
  )
}
